import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, message } from 'antd';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import styles from './ComponentDialog.module.scss';
import { useTranslation } from 'react-i18next';
import successImg from '@/assets/images/路径 1751@2x.png';
import { useNavigate,useLocation } from 'react-router-dom';
export type OrderDialogMode = 'bidding' | 'fixed';

export type OrderDialogOrder = {
    isShowFooter: boolean;
    title: string;
    text: number | string;
    toPage: string;
};

export type OrderDialogProps = {
    open: boolean;
    mode: OrderDialogMode;
    info: OrderDialogOrder;
    defaultBid?: number;
    onConfirm: () => void;
    onCancel: () => void;
    onNavigate: () => void;
};

const ComponentDialog: React.FC<OrderDialogProps> = ({ open, mode, info, defaultBid, onConfirm, onCancel,onNavigate }) => {

    const dispatch = useAppDispatch();
    // 获取用户信息和位置信息
    const userInfo = useAppSelector((state) => state.user.userInfo);
    //国际化
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
       
    }, [open, defaultBid, info, mode]);
    // const onNavigate = async () => {
    //     navigate(`/payment_success`); // 跳转到支付成功页面
    // };

    // 检查会员状态
    useEffect(() => {
        console.log("currentInfo===",info)
        // 判断是否是会员
        if(userInfo?.vip_info?.length){
         
        }
    },[userInfo]);

    return (
        <>
            <Modal
                open={open}
                footer={null}
                closable={false}
                width={577}
                className={styles.orderDialog}
            >
            <div className={styles.container}>
                <div className={styles.header}>
                    <button className={styles.closeBtn} onClick={onCancel} aria-label="Close" />
                </div>
                <div className={styles.center}>
                    <img className={styles.successImg} src={successImg} />
                    <div className={styles.title}>{info.title}</div>   
                    <div className={styles.text}>{info.text}</div> 
                    <div className={styles.topage} onClick={onNavigate}> {info.toPage} </div>            
                </div>
                {info.isShowFooter && 
                <div className={styles.footer}>
                    <button className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
                    <button className={styles.releaseBtn} onClick={onConfirm}>Release</button>
                </div>
                }
            </div>
            </Modal>

        
        </>
    );
};

export default ComponentDialog;

